"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.caMyHomeEventCategories = exports.caEventCategories = void 0;
var _types = require("../types");
/**
 * С помощью константы определяем поле category в отправляемой аналитике
 * */
const caEventCategories = exports.caEventCategories = {
  [_types.EEstimationTargets.flat]: 'EstateCalculator',
  [_types.EEstimationTargets.house]: 'EstateHouseCalculator',
  [_types.EEstimationTargets.land]: 'EstateLandCalculator',
  [_types.EEstimationTargets.newbuilding]: 'EstateCalculatorJK'
};
const caMyHomeEventCategories = exports.caMyHomeEventCategories = {
  [_types.EEstimationTargets.flat]: 'MyHomeFlat',
  [_types.EEstimationTargets.house]: 'MyHomeLand',
  [_types.EEstimationTargets.land]: 'MyHomeHouse'
};